export const SET_HEADER_TITLE = 'SET_HEADER_TITLE'
export const OPEN_SIDE_NAV = 'OPEN_SIDE_NAV'
export const CLOSE_SIDE_NAV = 'CLOSE_SIDE_NAV'
export const SHOW_AUTH_POPUP = 'SHOW_AUTH_POPUP'
